import * as React from "react";
import styled from "styled-components";
import { Button } from "components/bootstrap";
import IfPermitted from "components/common/IfPermitted";
import useSendTelemetry from "logic/telemetry/useSendTelemetry";
import { TELEMETRY_EVENT_TYPE } from "telemetry/Constants";
import useApplySuggestion from "../hooks/useApplySuggestion";
import useDismissSuggestion from "../hooks/useDismissSuggestion";
const Row = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacings.sm};
  padding: ${({ theme }) => `${theme.spacings.xs} ${theme.spacings.sm}`};
  border-bottom: 1px solid ${({ theme }) => theme.colors.table.row.divider};
  opacity: ${({ $muted }) => $muted ? 0.6 : 1};
`;
const KindSummary = styled.div`
  font-size: 0.85em;
  opacity: 0.75;
`;
const Reason = styled.div`
  font-size: 0.85em;
  font-style: italic;
  opacity: 0.8;
`;
const Actions = styled.div`
  white-space: nowrap;
`;
const summary = (s) => {
  if (s.kind === "ADD_EXCLUSION" && s.payload.type === "add_exclusion") {
    const fieldSummary = `Exclude ${s.payload.field} IN [${s.payload.values.join(", ")}]`;
    return s.payload.query_string ? `${fieldSummary} (${s.payload.query_string})` : fieldSummary;
  }
  if (s.kind === "UPDATE_QUERY_STRING" && s.payload.type === "update_query_string") {
    return `Replace query with: ${s.payload.new_query}`;
  }
  return "";
};
const SuggestionRow = ({ suggestion }) => {
  const sendTelemetry = useSendTelemetry();
  const apply = useApplySuggestion();
  const dismiss = useDismissSuggestion();
  const isSuggested = suggestion.status === "SUGGESTED";
  const kindSummary = summary(suggestion);
  const hasDescription = Boolean(suggestion.description);
  const primary = hasDescription ? suggestion.description : kindSummary;
  const onApply = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.AI_AGENT_WORKFLOW.SUGGESTION_APPLIED, {
      app_section: "aiagent-suggestions",
      event_details: { suggestion_kind: suggestion.kind }
    });
    apply.mutate(suggestion.id);
  };
  const onDismiss = () => {
    sendTelemetry(TELEMETRY_EVENT_TYPE.AI_AGENT_WORKFLOW.SUGGESTION_DISMISSED, {
      app_section: "aiagent-suggestions",
      event_details: { suggestion_kind: suggestion.kind }
    });
    dismiss.mutate(suggestion.id);
  };
  return /* @__PURE__ */ React.createElement(Row, { $muted: !isSuggested }, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("strong", null, primary)), hasDescription && /* @__PURE__ */ React.createElement(KindSummary, null, kindSummary), /* @__PURE__ */ React.createElement(Reason, null, suggestion.reason), !isSuggested && /* @__PURE__ */ React.createElement("em", null, "(", suggestion.status.toLowerCase(), ")")), /* @__PURE__ */ React.createElement(IfPermitted, { permissions: `eventdefinitions:edit:${suggestion.event_definition_id}` }, /* @__PURE__ */ React.createElement(Actions, null, /* @__PURE__ */ React.createElement(Button, { bsSize: "xsmall", bsStyle: "primary", disabled: !isSuggested || apply.isPending, onClick: onApply }, "Apply"), " ", /* @__PURE__ */ React.createElement(Button, { bsSize: "xsmall", disabled: !isSuggested || dismiss.isPending, onClick: onDismiss }, "Dismiss"))));
};
export default SuggestionRow;
